var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-page',[_c('Tree',{staticStyle:{"max-width":"500px"},attrs:{"data":_vm.data,"render":_vm.renderContent}}),_c('menu-item',{ref:"item",on:{"on-update":_vm.handleUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }